import { render, staticRenderFns } from "./RoleSaveForm.vue?vue&type=template&id=15a51e94"
import script from "./RoleSaveForm.vue?vue&type=script&lang=js"
export * from "./RoleSaveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports